import React from 'react';
import { createDisplayLink } from '../../../../services/helper';
import Image from 'next/image';

interface Props {
  heading: string;
  description: string;
  logo: string;
  customBackgroundColor?: string;
}

const Slot = ({ heading, description, logo, customBackgroundColor }: Props) => {
  return (
    <>
      <div
        className={`h-60 break-words mr-10 mt-10 text-base text-left py-8 px-6 relative`}
        style={{ backgroundColor: customBackgroundColor ? customBackgroundColor : '#004281' }}>
        <p className="mb-6 text-3xl text-white heading">{heading}</p>
        <p className="text-white hyphens-manual" dangerouslySetInnerHTML={{ __html: description }} />
        {logo && (
          <div className="absolute top-0 right-0 size-20 border border-[#004281] bg-[#0f2350] ">
            <Image fill className="object-contain object-center" alt={heading} src={createDisplayLink(logo)} />
          </div>
        )}
      </div>
    </>
  );
};

export default Slot;
